import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class EntityIconsService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Create entity icon
	 * @param {String} type
	 * @param {Object} data
	 */
	createEntityIcon(type, data, callback) {
		const url = `/ecosystem/api/entityIcons/${type}`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Get all  entityIcons by type
	 * @param {String} type
	 */
	getAllEntityIconsByType(type, callback) {
		const url = `/ecosystem/api/entityIcons/${type}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * delete an  entityIcon by type
	 * @param {String} id
	 * @param {String} type
	 */
	updateEntityIconByType(id, type, data, callback) {
		const url = `/entityIcons/${type}/${id}`;
		const body = JSON.stringify({
			data
		});
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * delete an  entityIcon by type
	 * @param {String} id
	 * @param {String} type
	 */
	deleteEntityIconByType(id, type, callback) {
		const url = `/ecosystem/api/entityIcons/${type}/${id}`;
		this._restClient.exec_delete(url, callback);
	}
}
